import { state } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import { todayDisplayDate } from "@hub/tenant/src/helpers/accessPeriod.helper"

export const initialState = () => ({
  ...state,
  uuid: null,
  isEditing: false,
  steps: ["Informações", "Módulos", "Perfis", "Integrador", "Venda", "Biometria"],
  stepsNamedRoutes: ["", "tenant-informations", "tenant-modules", "tenant-profiles", "tenant-integrator", "tenant-sale-options", "tenant-biometry"],
  currentStep: 0,
  tenant: {
    name: "",
    searchable: "",
    URL: "",
    mainColor: "",
    secondaryColor: "",
    slug: "",
    prefix: "",
    active: false,
    startDate: todayDisplayDate(),
    endDate: "",
    modules: [],
    profiles: [],
    integrator: "",
    credit_integrator: "",
    coverage_integrator: "",
    username: "",
    credit_username: "",
    coverage_username: "",
    integratorUrl: "",
    password: "",
    credit_password: "",
    coverage_password: "",
    collapsibles: {
      integrator: false,
      credit_integrator: false,
      coverage_integrator: false,
      bepeople: false
    },
    integrator_info_status: {
      credit: false,
      coverage: false,
      bepeople: false
    },
    integratorOptions: [],
    creditIntegratorOptions: [],
    coverageIntegratorOptions: [],
    dueDays: [],
    paymentTypes: [],
    shippingMethods: [],
    allow_cache: false,
    cache_expiration_time: 0,
    allow_only_qualified_legal_responsible: false,
    allow_add_legal_responsible: false,
    score_min: "",
    score_max: "",
    sendLinkByWhatsapp: false,
    whatsappSendOrigin: null,
    version: "v1",
    resendLinkInterval: 0,
    qrCodeValidityTime: 0
  },
  loading: {
    isLoading: false,
    message: ""
  },
  paymentTypesOptions: [],
  shippingMethodsOptions: [],
})
